import store from '@/store/store';

import App from '@/components/App';
import Home from '@/components/Home';
import Connexion from '@/components/connexion/connexion';
import ReinitialisationMdp from '@/components/connexion/reinitialisationMotDePasse';
import LoginRequired from '@/loginRequired';
import ListeDevis from '@/components/devisCommandes/rechercheDevis';
import ListeCommande from '@/components/devisCommandes/rechercheCommande/listeCommande';
import EcheancesCommande from '@/components/devisCommandes/rechercheCommande/echeancierCommande';
import RenouvellementCommande from '@/components/devisCommandes/renouvellementCommande';
import rechercheCommande from '@/components/devisCommandes/rechercheCommande/rechercheCommande';
import detailDevis from '@/views/bodac/devis/c_devis';
import detailCommande from '@/views/bodac/commandes/c_commande';
import detailFacture from '@/components/devisCommandes/detailDevisCommande/detailFacture';
import detailFactureVenteInterne from '@/views/bodac/factures/c_factureVenteInterne';
import detailFactureAchatVenteInterne from '@/views/bodac/factures/c_factureAchatVenteInterne';
import ListeFacture from '@/views/bodac/factures/l_Facture';
import ListeLignesFactureContainer from '@/views/bodac/lignesFacture/l_lignesFactureContainer';
import AjoutDevis from '@/components/devisCommandes/m_ajoutDevis';
import EditionCommande from '@/components/devisCommandes/m_editionCommande';
import catalogue from '@/views/bodac/catalogue/l_catalogue';
import ListeProduitsModulePresse from '@/views/bodac/catalogue/l_produitsModulePresse';
import planingNumerique from '@/views/bodac/catalogue/planning/l_planningReseauNumerique';
import typeProduitCreation from '@/views/bodac/catalogue/c_typeProduitCreation';
import EditionProduitReseau from '@/views/bodac/catalogue/m_editionProduitReseau';
import EditionProduitReseauLC from '@/views/bodac/catalogue/m_editionProduitReseauLC';
import EditionProduitReseauNumerique from '@/views/bodac/catalogue/m_editionProduitReseauNumerique';
import EditionProduitLocation from '@/views/bodac/catalogue/m_editionProduitLocation';
import EditionProduitLocationNumerique from '@/views/bodac/catalogue/m_editionProduitLocationNumerique';
import EditionProduitDivers from '@/views/bodac/catalogue/m_editionProduitDivers';
import EditionProduitDispositif from '@/views/bodac/catalogue/m_editionProduitDispositif';
import EditionProduitNumerique from '@/views/bodac/catalogue/m_editionProduitNumerique';
import EditionProduitFace from '@/views/bodac/catalogue/m_editionProduitFace';
import EditionProduitReseauMairie from '@/views/bodac/catalogue/m_produitReseauMairie';
import ListeClients from '@/views/bodac/clients/clients/l_Clients';
import EditionClient from '@/views/bodac/clients/clients/m_Client';
import CompteTiers from '@/components/tiers/m_CompteClient';
import EnCoursClient from '@/components/tiers/m_EnCoursClient';
import DetailClient from '@/views/bodac/clients/clients/c_Client';
import DetailOrganisationClient from '@/views/bodac/clients/clients/c_organisation';
import ListeContacts from '@/views/bodac/clients/contacts/l_Contacts';
import DetailContact from '@/views/bodac/clients/contacts/c_Contacts';
import EditionContact from '@/views/bodac/clients/contacts/m_Contacts';
import GestionFacture from '@/views/bodac/factures/m_gestionFacture';
import RemiseBancaire from '@/views/bodac/remiseBancaire/l_remiseBancaire';
import JournalReglements from '@/views/bodac/journalReglements/l_journalReglements';
import JournalPaiements from '@/views/baux/journalPaiements/l_journalPaiements';
import AddReglementInRemiseBancaire from '@/views/bodac/remiseBancaire/m_ajoutModificationReglement';
import AddReglementPieceRemiseBancaire from '@/views/bodac/remiseBancaire/m_reglementPiece';
import DetailRemiseBancaire from '@/views/bodac/remiseBancaire/c_detailRemiseBancaire';
import Client from '@/views/bodac/clients/clients/l_InterfaceClient';
import Parametrage from '@/views/bodac/parametrage/c_parametrage';
import Role from '@/views/bodac/parametrage/role/l_role';
import ProduitLocation from '@/views/bodac/catalogue/c_detailProduitLocation';
import ProduitLocationNumerique from '@/views/bodac/catalogue/c_detailProduitLocationNumerique';
import DetailEcranNumerique from '@/views/bodac/catalogue/c_detailEcranNumerique';
import ProduitDivers from '@/views/bodac/catalogue/c_detailProduitDivers';
import ProduitDispositif from '@/views/bodac/catalogue/c_detailProduitDispositif';
import DetailProduitReseau from '@/views/bodac/catalogue/c_detailProduitReseau';
import DetailProduitReseauLc from '@/views/bodac/catalogue/c_detailProduitReseauLc';
import DetailProduitReseauMairie from '@/views/bodac/catalogue/c_produitReseauMairie';
import DetailProduitReseauNumerique from '@/views/bodac/catalogue/c_detailProduitReseauNumerique';
import MouvementLettrage from '@/components/tiers/m_lettrageEnCoursTiers';
import AjoutUtilisateur from '@/views/bodac/parametrage/utilisateur/m_ajoutUtilisateur';
import EditionUtilisateur from '@/views/bodac/parametrage/utilisateur/m_editionUtilisateur';
import GestionRole from '@/views/bodac/parametrage/role/m_gestionRole';
import ListeUtilisateurs from '@/views/bodac/parametrage/utilisateur/l_utilisateurs';
import Relances from '@/views/bodac/relances/l_relances';
import ListeDesRetards from '@/components/relances/l_listeDesRetards';
import ListeRelancesSave from '@/components/relances/l_listeRelancesSave';
import DetailRole from '@/views/bodac/parametrage/role/c_detailRole';
import DetailRelance from '@/views/bodac/relances/c_detailRelance';
import editionRelance from '@/views/bodac/relances/m_editionRelance';
import ajoutRelance from '@/views/bodac/relances/m_ajoutRelance';
import ProduitFace from '@/views/bodac/catalogue/c_detailProduitFace';
import ListeSocietes from '@/views/bodac/parametrage/societes/l_societes';
import EditionSocietes from '@/views/bodac/parametrage/societes/m_societe';
import DetailCollaborateur from '@/views/bodac/parametrage/utilisateur/c_utilisateur';
import DetailSociete from '@/views/bodac/parametrage/societes/c_societe';
import ajoutAgence from '@/views/bodac/parametrage/societes/m_agence';
import EditionEcheancierPaiement from '@/views/bodac/factures/m_echeancierPaiementFactureEnregistree';
import ListeModeReglement from '@/views/bodac/parametrage/modeReglement/l_modeReglement';
import ListeDomiciliationBancaire from '@/views/bodac/parametrage/domiciliationBancaire/l_domiciliationBancaire';
import EditionDomiciliationBancaire from '@/views/bodac/parametrage/domiciliationBancaire/m_domiciliationBancaire';
import DetailDomiciliationBancaire from '@/views/bodac/parametrage/domiciliationBancaire/c_domiciliationBancaire';
import ReseauTempo from '@/views/bodac/disponibilite/c_planningReseauTempo';
import DetailPlanningNumerique from '@/views/bodac/disponibilite/c_planningNumerique';
import FaceUnitairePlanning from '@/views/bodac/disponibilite/c_planningFaceUnitaire';
import ListeSchemaComptable from '@/views/bodac/parametrage/schemaComptable/l_schemaComptable';
import ListeNatureProduit from '@/views/bodac/parametrage/natureProduit/l_natureProduit';
import EditionSchemaComptable from '@/views/bodac/parametrage/schemaComptable/m_schemaComptable';
import DetailSchemaComptable from '@/views/bodac/parametrage/schemaComptable/c_schemaComptable';
import RechercheProduitUnitaire from '@/components/devisCommandes/rechercheCatalogue/c_rechercheProduitUnitaire';
import AjoutReseauLc from '@/views/bodac/disponibilite/c_ajoutReseauLc';
import AjoutReseauMairieInDcf from '@/views/bodac/disponibilite/c_ajoutReseauMairie';
import PlanningReseauLc from '@/views/bodac/catalogue/planning/c_planningReseauLc';
import ListeCommentaire from '@/views/bodac/parametrage/commentaire/l_commentaire';
import ListeRemise from '@/views/bodac/parametrage/remise/l_remise';
import ListeProduitsAchats from '@/views/bodac/parametrage/produit/l_produitsAchat';
import AjoutFacesAuReseau from '@/components/catalogue/produitReseau/ajoutFaces/m_ajoutFaces';
import ListeContratNature from '@/views/bodac/parametrage/contratNature/l_contratNature';
import ListeContratSignataire from '@/views/bodac/parametrage/contratSignataire/l_contratSignataire';
import ListeFormat from '@/views/bodac/parametrage/format/l_format';
import ListeTypeReseau from '@/views/bodac/parametrage/typeReseau/l_typeReseau';
import ListeSecteurActivite from '@/views/bodac/parametrage/secteurActivite/l_secteurActivite';
import ListeCivilite from '@/views/bodac/parametrage/civilite/l_civilite';
import ListeDispositifSupport from '@/views/bodac/parametrage/dispositifSupport/l_dispositifSupport';
import ListeDispositifType from '@/views/bodac/parametrage/dispositifType/l_dispositifType';
import ListeMaterielLocalisation from '@/views/bodac/parametrage/materielLocalisation/l_materielLocalisation';
import ListeMaterielAngleVision from '@/views/bodac/parametrage/materielAngleVision/l_materielAngleVision';
import ListeMaterielFormat from '@/views/bodac/parametrage/materielFormat/l_materielFormat';
import ListeMaterielType from '@/views/bodac/parametrage/materielType/l_materielType';
import ListeFaceMotifNonCom from '@/views/bodac/parametrage/faceMotifNonCom/l_faceMotifNonCom';
import ListeMotifBlocage from '@/views/bodac/parametrage/motifBlocage/l_motifBlocage';
import ParametrageEdtion from '@/views/bodac/parametrage/edition/l_parametrageEdtion';
import ListeProduitAchatsLoc from '@/views/baux/produitAchatLoc/l_produitsAchatLoc';
import ListeReseauTempo from '@/views/bodac/catalogue/l_produitReseauTempo';
import ListeReseauLc from '@/views/bodac/catalogue/l_produitReseauLc';
import ListeReseauMairie from '@/views/bodac/catalogue/l_produitReseauMairie';
import ListeReseauNumerique from '@/views/bodac/catalogue/l_produitReseauNumerique';
import BudgetForClient from '@/components/clients/clients/budget/budget';
import ListeTypePointVente from '@/views/bodac/parametrage/typePointVente/l_typePointVente';
import ListeProfilTiers from '@/views/bodac/parametrage/profilTiers/l_profilTiers';
import ListeReseauTempoDispo from '@/views/bodac/outils/reseauTempo/l_produitReseauTempoDispo';
import Cartographie from '@/views/bodac/outils/cartographie/c_cartographie';
import ListeRelanceOption from '@/views/bodac/relanceOption/l_relanceOption';
import ListeDelaiReglement from '@/views/bodac/parametrage/delaiReglement/l_delaiReglement';
import ListeProduitFace from '@/views/bodac/catalogue/l_produitFace';
import ListeRegroupementProduit from '@/views/bodac/catalogue/l_regroupementProduit';
import AddEditRegroupementProduit from '@/views/bodac/catalogue/m_editionRegroupementProduit';
import MAjoutProduitsSurRegroupement from '@/components/presse/regroupementProduit/produits/m_ajoutProduitsSurRegroupement';
import DetailRegroupementProduit from '@/views/bodac/catalogue/c_regroupementProduit';
import ListeDemande from '@/views/bodac/demandeTempo/l_demandeTempo';
import ListeTypeTaxationTlpe from '@/views/bodac/parametrage/typeTaxationTlpe/l_typeTaxationTlpe';
import AddEditTypeTaxationTlpe from '@/views/bodac/parametrage/typeTaxationTlpe/m_typeTaxationTlpe';
import editRemiseBancaire from '@/views/bodac/remiseBancaire/m_remiseBancaire';
import ListeRegimeTva from '@/views/bodac/parametrage/regimeTva/l_regimeTva';
import ListeCompteAnalytique from '@/views/bodac/parametrage/compteAnalytique/l_compteAnalytique';
import EcheancesBonAFacturer from '@/components/devisCommandes/rechercheCommande/echeancesBonAFacturer';
import detailPortail from '@/views/bodac/clients/clients/c_portail';
import ListeLignesCommandeManager from '@/views/bodac/lignesCommande/l_lignesCommandeManager';
import ListeCategorieGroupeProduitDeductible
  from '@/views/bodac/parametrage/categorieGroupeProduitDeductible/l_categorieGroupeProduitDeductible';
import CommandeAFacturer from '@/components/devisCommandes/rechercheCommande/commandeAFacturer';
import AjoutProduitAssocie from '@/views/bodac/catalogue/produitAssocie/m_ajoutProduitAssocie';
import Indexation from '@/views/bodac/parametrage/indexation/m_indexation';
import ListeAccessoire from '@/views/bodac/parametrage/accessoire/l_accessoire';
import ListeRelancesCommun from '@/views/bodac/relancesCommun/l_relances';
import listeTypeOt from '@/views/bodac/parametrage/typeOt/l_typeOt';
import detailTypeOt from '@/views/bodac/parametrage/typeOt/c_typeOt';
import addEditTypeOt from '@/views/bodac/parametrage/typeOt/m_typeOt';
import detailImageProduit from '@/views/bodac/catalogue/c_detailImageProduit';
import ListeVentesForClient from '@/views/bodac/clients/clients/c_ventes';
import DetailCommandeAchatVenteInterne from '@/views/bodac/commandes/c_commandeAchatVenteInterne';
import DetailCommandeVenteInterne from '@/views/bodac/commandes/c_commandeVenteInterne';
import EditionProduitSalon from '@/views/bodac/catalogue/m_editionProduitSalon';
import DetailProduitSalon from '@/views/bodac/catalogue/c_detailProduitSalon';
import EditionProduitAutre from '@/views/bodac/catalogue/m_editionProduitAutre';
import DetailProduitAutre from '@/views/bodac/catalogue/c_detailProduitAutre';
import DetailProduitSponsoring from '@/views/bodac/catalogue/c_detailProduitSponsoring';
import EditionProduitSponsoring from '@/views/bodac/catalogue/m_editionProduitSponsoring';
import ListeTypeContact from '@/views/bodac/parametrage/l_typeContact';
import EditionProduitPresse from '@/views/bodac/catalogue/m_editionProduitPresse';
import DetailProduitPresse from '@/views/bodac/catalogue/c_detailProduitPresse';
import AjoutProduitSalonInDcf from '@/views/bodac/disponibilite/c_ajoutProduitSalon';
import AjoutProduitSponsoringInDcf from '@/views/bodac/disponibilite/c_ajoutProduitSponsoring';
import AjoutProduitAutreInDcf from '@/views/bodac/disponibilite/c_ajoutProduitAutre';
import AjoutProduitPresseInDcf from '@/views/bodac/disponibilite/c_ajoutProduitPresse';
import detailCommandeCommission from '@/views/bodac/commandes/c_commandeCommission';
import EcheancePaiement from '@/views/bodac/echeancePaiement/l_echeancePaiement';
import ListeRetrocession from '@/views/bodac/retrocession/l_retrocession';
import ListeMotifAnnulationReglement from '@/views/bodac/parametrage/motifAnnulationReglement/l_motifAnnulationReglement';
import ListeFactor from '@/views/bodac/factor/l_factor';
import ListeTransmission from '@/views/bodac/factor/l_transmission';
import editionFournisseur from '@/views/commun/fournisseur/m_fournisseur';
import detailFournisseur from '@/views/commun/fournisseur/c_fournisseur';
import EditionAgenceEditionBat from '@/views/bodac/parametrage/societes/m_agenceEditionBat';
import EditionAgenceMailBat from '@/views/bodac/parametrage/societes/m_agenceMailBat';
import ListeReleve from '@/views/bodac/outils/editionProduit/l_releve';
import RegleFacturation from '@/views/bodac/parametrage/regleFacturation/l_regleFacturation';
import AddEditRegleFacturation from '@/views/bodac/parametrage/regleFacturation/m_regleFacturation';
import DetailRegleFacturation from '@/views/bodac/parametrage/regleFacturation/c_regleFacturation';
import ListeSignatureElectronique from '@/views/commun/signatureElectronique/l_signatureElectronique';
import ListeIndiceEtValeur from '@/views/bodac/parametrage/indiceEtValeur/l_indiceEtValeur';
import AddEditIndiceEtValeur from '@/views/bodac/parametrage/indiceEtValeur/m_indiceEtValeur';
import ListeMarque from '@/views/bodac/parametrage/marque/l_marque';
import ListeDispositifsForClient from '@/views/bodac/clients/clients/c_dispositifsForClients';
import ListeMouvementStock from '@/views/bodac/clients/clients/c_mouvementStock';
import ListLignesDevis from '@/views/bodac/lignesDevis/l_lignesDevis';
import ListeTags from '@/views/bodac/parametrage/tag/l_tag';
import ListeCampagnes from '@/views/bodac/campagne/l_campagne';
import EditionCampagne from '@/views/bodac/campagne/m_campagne';
import DetailCampagne from '@/views/bodac/campagne/c_campagne';
import ListeLignesCmdARenouveler from '@/components/bodac/lignesCommande/l_lignesCommandeARenouveler';
import ListeNomenclatureType from '@/views/bodac/parametrage/nomenclatureType/l_nomenclatureType';
import AddEditNomenclatureType from '@/views/bodac/parametrage/nomenclatureType/m_nomenclatureType';
import ListePlanMedia from '@/views/bodac/planMedia/l_planMedia';
import AddEditPlanMedia from '@/views/bodac/planMedia/m_planMedia';
import DetailPlanMedia from '@/views/bodac/planMedia/c_planMedia';
import ImportIdelia from '@/views/bodac/import/m_importIdelia';
import ListeSecteur from '@/views/bodac/parametrage/secteur/l_secteur';
import SuiviAffectationProduitFace from '@/views/bodac/outils/suiviAffectation/l_suivi_affectation';
import ListeDemandeImpression from '@/views/bodac/clients/clients/l_demandeImpressionClient';
import ListeProduitEcranNumerique from '@/views/bodac/catalogue/l_produitEcranNumerique';
import ListePays from '@/views/bodac/parametrage/pays/l_pays';
import ListeFonctionContact from '@/views/bodac/parametrage/fonctionContact/l_fonctionContact';
import ListeDesRetardsClient from '@/views/bodac/clients/clients/l_listeDesRetardsClient';
import ListeVenteDevis from '@/views/bodac/clients/clients/c_ventesDevis';
import OngletFactureClient from '@/views/bodac/clients/clients/ongletFactureClient';
import ListeCompetenceFournisseur from '@/views/bodac/parametrage/competenceFournisseur/l_competenceFournisseur';
import ListeNatureSupportAffiche from '@/views/bodac/parametrage/natureSupportAffiche/l_natureSupportAffiche';
import EditionProduitImpressionAffiche from '@/views/bodac/parametrage/produit/m_editionProduitImpressionAffiche';
import DetailProduitImpressionAffiche from '@/views/bodac/parametrage/produit/c_detailProduitImpressionAffiche';
import TypeProduitCreationAchat from '@/views/bodac/parametrage/produit/c_typeProduitCreationAchat';
import ListeFormatAffiche from '@/views/bodac/parametrage/formatAffiche/l_formatAffiche';
import EditionFormatAffiche from '@/views/bodac/parametrage/formatAffiche/m_formatAffiche';
import DetailFormatAffiche from '@/views/bodac/parametrage/formatAffiche/c_formatAffiche';
import ListeService from '@/views/bodac/parametrage/service/l_service';
import EditionService from '@/views/bodac/parametrage/service/m_service';
import ConsultationFournisseurs from '@/views/achat/fournisseurs/c_fournisseurs';

export default [
  {
    path: '/connexion',
    component: Connexion,
    name: 'connexion',
  },
  {
    path: '/',
    name: 'App',
    component: App,
    children: [
      {
        path: '/home',
        component: Home,
        name: 'home',
      },
      {
        path: '/liste-devis/:sens?/:tiersId?',
        component: ListeDevis,
        name: 'l.bodac.devis',
      },
      {
        path: '/devis/:id',
        component: detailDevis,
        name: 'c.bodac.devis',
      },
      {
        path: '/listeLignesDevis',
        component: ListLignesDevis,
        name: 'l.bodac.devis-liste',
      },
      {
        path: '/devis/:id/sanssuite/:displayToastClasserSansSuite',
        component: detailDevis,
        name: 'c.bodac.devis-sansSuite',
      },
      {
        path: '/recherche-produit',
        component: RechercheProduitUnitaire,
        name: 'rechercheProduitUnitaire',
      },
      {
        path: '/planningReseauTemporaire',
        component: ReseauTempo,
        name: 'c.bodac.planning-reseauTempo',
      },
      {
        path: '/listeLignesCommande',
        component: ListeLignesCommandeManager,
        name: 'l.bodac.commandes-lignesCmd',
      },
      {
        path: '/listeLignesCommandeParProduit/:produitId?/:typeLocationOrDivers?',
        component: ListeLignesCommandeManager,
        name: 'l.bodac.commandes-lignesCmd-par-produit',
      },
      {
        path: '/liste-commande/:sens?/',
        component: ListeCommande,
        children: [
          {
            path: 'echeancesCommande',
            component: EcheancesCommande,
            name: 'l.bodac.commandes-echeances',
          },
          {
            path: 'echeancesCommande/:parutionId',
            component: EcheancesCommande,
            name: 'l.bodac.commandes-echeances-par-parution',
          },
          {
            path: 'commandeAFacturer',
            component: CommandeAFacturer,
            name: 'l.bodac.commandes-aFacturer',
          },
          {
            path: 'commandeAFacturer/:parutionId',
            component: CommandeAFacturer,
            name: 'l.bodac.commandes-aFacturer-par-parution',
          },
          {
            path: 'echeancesAFacturer',
            component: EcheancesBonAFacturer,
            name: 'l.bodac.commandes-echeancesBonAFacturer',
          },
          {
            path: 'rechercheCommande/:tiersId?',
            component: rechercheCommande,
            name: 'l.bodac.commandes-liste',
          },
          {
            path: 'rechercheCommandeParProduit/:produitId?',
            component: rechercheCommande,
            name: 'l.bodac.commandes-liste-par-produit',
          },
          {
            path: 'rechercheCommandeParParution/:parutionId?',
            component: rechercheCommande,
            name: 'l.bodac.commandes-liste-par-parution',
          },
          {
            path: 'rechercheCommandeWithReferenceIds/:referenceId?',
            component: rechercheCommande,
            name: 'l.bodac.commandes-listeReferencesId',
          },
          {
            path: 'rechercheCommandeWithReferences/:idsCommande?/:idFacture?',
            component: rechercheCommande,
            name: 'l.bodac.commandes-listeReferences',
          },
          {
            path: 'renouvellementCommande',
            component: RenouvellementCommande,
            name: 'l.bodac.commandes-renouvellement',
          },
        ],
      },
      {
        path: '/commande/:id',
        component: detailCommande,
        name: 'c.bodac.commandes',
      },
      {
        path: '/commande/:id/sanssuite/:displayToastClasserSansSuite',
        component: detailCommande,
        name: 'c.bodac.commandes-sansSuite',
      },
      {
        path: '/commande/:id/cloture/:displayToastCloture',
        component: detailCommande,
        name: 'c.bodac.commandes-cloture',
      },
      {
        path: 'commandeAchatVenteInterne/:id',
        component: DetailCommandeAchatVenteInterne,
        name: 'c.bodac.commandes-achatVenteInterne',
      },
      {
        path: '/commandeCommissions/:id',
        component: detailCommandeCommission,
        name: 'c.bodac.commandes-commission',
      },
      {
        path: 'commandeVenteInterne/:id',
        component: DetailCommandeVenteInterne,
        name: 'c.bodac.commandes-venteInterne',
      },
      {
        path: '/liste-facture/',
        component: ListeFacture,
        children: [
          {
            path: 'recherche/:sens?/:tiersId?',
            component: ListeFacture,
            name: 'l.bodac.factures',
          },
          {
            path: 'ParProduit/:sens?/:produitId?',
            component: ListeFacture,
            name: 'l.bodac.factures-par-produit',
          },
          {
            path: 'ParParution/:parutionId',
            component: ListeFacture,
            name: 'l.bodac.factures-par-parution',
          },
          {
            path: 'ReferenceIds/:referenceIds?',
            component: ListeFacture,
            name: 'l.bodac.factures-referencesIds',
            props(route) {
              const referenceIds = route.params.referenceIds || '';
              return { referenceIds: referenceIds === '' ? [] : referenceIds.split('|') };
            },
          },
          {
            path: 'LiaisonCommande/:commandeId',
            component: ListeFacture,
            name: 'l.bodac.factures-liaison-commande',
          },
        ],
      },
      {
        path: '/facture/:id',
        component: detailFacture,
        name: 'c.bodac.factures',
      },
      {
        path: '/listeLignesFacture',
        component: ListeLignesFactureContainer,
        name: 'l.bodac.factures-lignes',
      },
      {
        path: '/listeLignesFactureParProduit/:produitId?',
        component: ListeLignesFactureContainer,
        name: 'l.bodac.factures-lignes-par-produit',
      },
      {
        path: '/factureAchatVenteInterne/:id',
        component: detailFactureAchatVenteInterne,
        name: 'c.bodac.factures-achatVenteInterne',
      },
      {
        path: '/factureVenteInterne/:id',
        component: detailFactureVenteInterne,
        name: 'c.bodac.factures-venteInterne',
      },
      {
        path: '/factureAchat/:id',
        component: detailFacture,
        name: 'c.bodac.factures-achat',
      },
      {
        path: '/edition-devis',
        component: AjoutDevis,
        name: 'm.bodac.devis-creation',
      },
      {
        path: '/edition-devis/:id',
        component: AjoutDevis,
        name: 'm.bodac.devis',
      },
      {
        path: '/edition-devis/client',
        component: AjoutDevis,
        name: 'm.bodac.devis-client',
      },
      {
        path: '/edition-devis-planMedia/:planMediaId/:typeEcran?',
        component: AjoutDevis,
        name: 'm.bodac.devis-planMedia',
      },
      {
        path: '/edition-commande',
        component: EditionCommande,
        name: 'm.bodac.commandes-ajout',
      },
      {
        path: '/edition-facture/client',
        component: GestionFacture,
        name: 'm.bodac.factures-client',
      },
      {
        path: '/edition-commande/:id/:renouveleOrTacite',
        component: EditionCommande,
        name: 'm.bodac.commandes-ajoutRenouvelOrTacite',
      },
      {
        path: '/edition-commande/client',
        component: EditionCommande,
        name: 'm.bodac.commandes-client',
      },
      {
        path: '/edition-commande/:id',
        component: EditionCommande,
        name: 'm.bodac.commandes',
      },
      {
        path: '/edition-commande-planMedia/:planMediaId/:typeEcran?',
        component: EditionCommande,
        name: 'm.bodac.commandes-planMedia',
      },
      {
        path: '/edition-facture',
        component: GestionFacture,
        name: 'm.bodac.factures',
      },
      {
        path: '/edition-facture/:id',
        component: GestionFacture,
        name: 'm.bodac.factures-edition',
      },
      {
        path: '/creation-avoir',
        component: GestionFacture,
        name: 'm.bodac.factures-avoir',
      },
      {
        path: '/liste-clients/:type?',
        component: ListeClients,
        name: 'l.bodac.clients/contacts-clients',
      },
      {
        path: '/edition-client',
        component: EditionClient,
        name: 'm.bodac.clients/contacts-addClient',
      },
      {
        path: '/edition-client/Commande',
        component: EditionClient,
        name: 'm.bodac.clients/contacts-editCommande',
      },
      {
        path: '/edition-client/Devis',
        component: EditionClient,
        name: 'm.bodac.clients/contacts-editDevis',
      },
      {
        path: '/edition-client/Facture',
        component: EditionClient,
        name: 'm.bodac.clients/contacts-editFacture',
      },
      {
        path: '/edition-client/PlanMedia/:planMediaId?',
        component: EditionClient,
        name: 'm.bodac.clients/contacts-editPlanMedia',
      },
      {
        path: '/edition-client/:id',
        component: EditionClient,
        name: 'm.bodac.clients/contacts-editClient',
      },
      {
        path: '/client/:id',
        children: [
          {
            path: 'detailClient',
            component: DetailClient,
            name: 'c.bodac.clients/contacts-client',
          },
          {
            path: 'enCoursClient',
            component: EnCoursClient,
            name: 'c.bodac.clients/contacts-enCours',
          },
          {
            path: 'compte',
            component: CompteTiers,
            name: 'c.bodac.clients/contacts-compte',
          },
          {
            path: 'organisation',
            component: DetailOrganisationClient,
            name: 'c.bodac.clients/contacts-organisation',
          },
          {
            path: 'budget',
            component: BudgetForClient,
            name: 'c.bodac.clients/contacts-budget',
          },
          {
            path: 'listeVentes',
            component: ListeVentesForClient,
            name: 'c.bodac.clients/contacts-listeVentes',
          },
          {
            path: 'portail',
            component: detailPortail,
            name: 'c.bodac.clients/contacts-portail',
          },
          {
            path: 'listeRelances',
            component: ListeRelancesCommun,
            name: 'c.bodac.clients/contacts-relances',
          },
          {
            path: 'devis',
            component: ListeVenteDevis,
            name: 'c.bodac.clients/contacts-devis',
          },
          {
            path: 'facture',
            component: OngletFactureClient,
            name: 'c.bodac.clients/contacts-factures',
          },
          {
            path: 'dispositfs',
            component: ListeDispositifsForClient,
            name: 'c.bodac.clients/contacts-dispositif',
          },
          {
            path: 'lignesCommandeARenouveler',
            component: ListeLignesCmdARenouveler,
            name: 'c.bodac.clients/contacts-ligne-commandes',
          },
          {
            path: 'mouvement-stock',
            component: ListeMouvementStock,
            name: 'c.bodac.clients/contacts-stock',
          },
          {
            path: 'demande-impression',
            component: ListeDemandeImpression,
            name: 'c.bodac.clients/contacts-demandeImpression',
          },
          {
            path: 'retard-paiement',
            component: ListeDesRetardsClient,
            name: 'c.bodac.clients/contacts-retardPaiement',
          },
        ],
        component: Client,
        name: 'client',
      },
      {
        path: '/mouvement/:id/lettrage/:isFromDetailClient',
        component: MouvementLettrage,
        name: 'm.bodac.remises_bancaires-client',
      },
      {
        path: '/liste-contacts/:type?',
        component: ListeContacts,
        name: 'l.bodac.clients/contacts-contacts',
      },
      {
        path: '/detail-contact/:id/:isFromBailleur?',
        component: DetailContact,
        name: 'c.bodac.clients/contacts-contacts',
      },
      {
        path: '/edition-contact/:id/:isFromBailleur?',
        component: EditionContact,
        name: 'm.bodac.clients/contacts-editContact',
      },
      {
        path: '/edition-contact',
        component: EditionContact,
        name: 'm.bodac.clients/contacts-addContact',
      },
      {
        path: '/catalogue/:typeProduit?',
        component: catalogue,
        name: 'l.bodac.catalogue',
      },
      {
        path: '/liste-produit-module-presse/:typeProduit',
        component: ListeProduitsModulePresse,
        name: 'l.bodac.catalogue-produitsModulePresse',
      },
      {
        path: '/planning/:typeProduit',
        component: planingNumerique,
        name: 'c.bodac.commandes-planningNumeriqueAjout',
      },
      {
        path: '/catalogue/ProduitLocation/:id/:isFromCatalogueAchat?',
        component: ProduitLocation,
        name: 'c.bodac.catalogue-location',
      },
      {
        path: '/catalogue/ecranNumerique/:id/:isFromListeProduitEcran?',
        component: DetailEcranNumerique,
        name: 'c.bodac.catalogue-ecranNumerique',
      },
      {
        path: '/catalogue/ProduitLocationNumerique/:id',
        component: ProduitLocationNumerique,
        name: 'c.bodac.catalogue-locationNumerique',
      },
      {
        path: '/catalogue/ProduitFace/:id/:isFromListeProduitFace?',
        component: ProduitFace,
        name: 'c.bodac.catalogue-face',
      },
      {
        path: '/catalogue/ProduitDivers/:id/:isFromCatalogueAchat?',
        component: ProduitDivers,
        name: 'c.bodac.catalogue-divers',
      },
      {
        path: '/catalogue/ProduitDispositif/:id/:isFromCatalogueAchat?',
        component: ProduitDispositif,
        name: 'c.bodac.catalogue-dispositif',
      },
      {
        path: '/catalogue/ProduitReseau/:id/:isFromListeProduitReseau?/:dateVisu?',
        component: DetailProduitReseau,
        name: 'c.bodac.catalogue-reseau',
      },
      {
        path: '/catalogue/ProduitReseauLc/:id/:isFromListeProduitReseauLc?/:dateVisu?',
        component: DetailProduitReseauLc,
        name: 'c.bodac.catalogue-reseauLc',
      },
      {
        path: '/catalogue/ProduitReseauMairie/:id/:isFromListeProduitReseauMairie?',
        component: DetailProduitReseauMairie,
        name: 'c.bodac.catalogue-reseauMairie',
      },
      {
        path: '/catalogue/ProduitReseauNumerique/:id/:isFromListeProduitReseauNum?/:dateVisu?',
        component: DetailProduitReseauNumerique,
        name: 'c.bodac.catalogue-reseauNumerique',
      },
      {
        path: '/listeProduit/:typeProduit',
        component: ListeProduitsModulePresse,
        name: 'l.bodac.catalogue-salon',
      },
      {
        path: '/catalogue/detailProduitSalon/:id',
        component: DetailProduitSalon,
        name: 'c.bodac.catalogue-detailSalon',
      },
      {
        path: '/catalogue/nouveau-produit/salon/:marcheId?',
        component: EditionProduitSalon,
        name: 'm.bodac.catalogue-nouveauSalon',
      },
      {
        path: '/catalogue/editionproduitSalon/:produitId',
        component: EditionProduitSalon,
        name: 'm.bodac.catalogue-editionSalon',
      },
      {
        path: '/rechercheProduitSalon',
        component: AjoutProduitSalonInDcf,
        name: 'c.bodac.commandes-salon',
      },
      {
        path: '/listeProduit/:typeProduit',
        component: ListeProduitsModulePresse,
        name: 'l.bodac.catalogue-produitPresse',
      },
      {
        path: '/catalogue/nouveau-produit/presse/:marcheId?',
        component: EditionProduitPresse,
        name: 'm.bodac.catalogue-nouveauPresse',
      },
      {
        path: '/catalogue/editionProduitPresse/:produitId',
        component: EditionProduitPresse,
        name: 'm.bodac.catalogue-editionPresse',
      },
      {
        path: '/catalogue/detailProduitPresse/:id',
        component: DetailProduitPresse,
        name: 'c.bodac.catalogue-detailPresse',
      },
      {
        path: '/catalogue/type-produit',
        component: typeProduitCreation,
        name: 'm.bodac.catalogue-typeCreation',
      },
      {
        path: '/catalogue/nouveau-produit/face/:isFromListeProduitFace?',
        component: EditionProduitFace,
        name: 'm.bodac.catalogue-nouvelleFace',
      },
      {
        path: '/catalogue/nouveau-produit/autre/:marcheId?',
        component: EditionProduitAutre,
        name: 'm.bodac.catalogue-nouveauAutre',
      },
      {
        path: '/catalogue/editionProduitAutre/:produitId',
        component: EditionProduitAutre,
        name: 'm.bodac.catalogue-editionAutre',
      },
      {
        path: '/catalogue/detailProduitAutre/:id',
        component: DetailProduitAutre,
        name: 'c.bodac.catalogue-detailAutre',
      },
      {
        path: '/catalogue/nouveau-produit/sponsoring/:marcheId?',
        component: EditionProduitSponsoring,
        name: 'm.bodac.catalogue-nouveauSponsoring',
      },
      {
        path: '/catalogue/editionProduitSponsoring/:produitId',
        component: EditionProduitSponsoring,
        name: 'm.bodac.catalogue-editionSponsoring',
      },
      {
        path: '/catalogue/detailProduitSponsoring/:id',
        component: DetailProduitSponsoring,
        name: 'c.bodac.catalogue-detailSponsoring',
      },
      {
        path: '/catalogue/nouveau-produit/reseau/:isFromListeProduitReseau?',
        component: EditionProduitReseau,
        name: 'm.bodac.catalogue-nouveauReseau',
      },
      {
        path: '/catalogue/nouveau-produit/reseauMairie/:isFromListeProduitReseauMairie?',
        component: EditionProduitReseauMairie,
        name: 'm.bodac.catalogue-nouveauReseauMairie',
      },
      {
        path: '/catalogue/nouveau-produit/reseau-lc/:isFromListeProduitReseauLc?',
        component: EditionProduitReseauLC,
        name: 'm.bodac.catalogue-nouveauReseauLc',
      },
      {
        path: '/catalogue/nouveau-produit/numerique',
        component: EditionProduitNumerique,
        name: 'm.bodac.catalogue-nouveauNumerique',
      },
      {
        path: '/catalogue/nouveau-produit/reseauNumerique',
        component: EditionProduitReseauNumerique,
        name: 'm.bodac.catalogue-nouveauReseauNumerique',
      },
      {
        path: '/catalogue/nouveau-produit/location/:isFromCatalogueAchat?',
        component: EditionProduitLocation,
        name: 'm.bodac.catalogue-nouveauLocation',
      },
      {
        path: '/catalogue/nouveau-produit/location-numerique',
        component: EditionProduitLocationNumerique,
        name: 'm.bodac.catalogue-nouveauLocationNumerique',
      },
      {
        path: '/catalogue/nouveau-produit/divers/:isFromCatalogueAchat?',
        component: EditionProduitDivers,
        name: 'm.bodac.catalogue-nouveauDivers',
      },
      {
        path: '/catalogue/nouveau-produit/dispositif/:isFromCatalogueAchat?',
        component: EditionProduitDispositif,
        name: 'm.bodac.catalogue-nouveauDispositif',
      },
      {
        path: '/catalogue/numerique/:produitId',
        component: EditionProduitNumerique,
        name: 'm.bodac.catalogue-editionNumerique',
      },
      {
        path: '/catalogue/reseau/:produitId/:isFromListeProduitReseau?',
        component: EditionProduitReseau,
        name: 'm.bodac.catalogue-editionReseau',
      },
      {
        path: '/catalogue/reseau-lc/:produitId/:isFromListeProduitReseauLc?',
        component: EditionProduitReseauLC,
        name: 'm.bodac.catalogue-editionReseauLc',
      },
      {
        path: '/catalogue/reseau-mairie/:produitId/:isFromListeProduitReseauMairie?',
        component: EditionProduitReseauMairie,
        name: 'm.bodac.catalogue-editionReseauMairie',
      },
      {
        path: '/catalogue/face/:produitId/:isFromListeProduitFace?',
        component: EditionProduitFace,
        name: 'm.bodac.catalogue-editionFace',
      },
      {
        path: '/catalogue/reseauNumerique/:produitId',
        component: EditionProduitReseauNumerique,
        name: 'm.bodac.catalogue-editionReseauNumerique',
      },
      {
        path: '/catalogue/location/:produitId/:isFromCatalogueAchat?',
        component: EditionProduitLocation,
        name: 'm.bodac.catalogue-editionLocation',
      },
      {
        path: '/catalogue/locationNumerique/:produitId',
        component: EditionProduitLocationNumerique,
        name: 'm.bodac.catalogue-editionLocationNumerique',
      },
      {
        path: '/catalogue/divers/:produitId/:isFromCatalogueAchat?',
        component: EditionProduitDivers,
        name: 'm.bodac.catalogue-editionDivers',
      },
      {
        path: '/catalogue/dispositif/:produitId/:isFromCatalogueAchat?',
        component: EditionProduitDispositif,
        name: 'm.bodac.catalogue-editionDispositif',
      },
      {
        path: '/listeProduitAchat/produitImpressionAffiche/:id',
        component: DetailProduitImpressionAffiche,
        name: 'c.bodac.catalogue-impressionAffiche',
      },
      {
        path: '/listeProduitAchat/impressionAffiche/:produitId',
        component: EditionProduitImpressionAffiche,
        name: 'm.bodac.catalogue-editionProduitImpressionAffiche',
      },
      {
        path: '/listeProduitAchat/type-produit',
        component: TypeProduitCreationAchat,
        name: 'm.bodac.catalogue-typeCreationAchat',
      },
      {
        path: '/listeProduitAchat/nouveau-produit/impressionAffiche',
        component: EditionProduitImpressionAffiche,
        name: 'm.bodac.catalogue-nouveauProduitImpressionAffiche',
      },
      {
        path: '/listeRemiseBancaire/:sens?',
        component: RemiseBancaire,
        name: 'l.bodac.remises_bancaires',
      },
      {
        path: '/journalReglements',
        component: JournalReglements,
        name: 'l.bodac.journal_reglements',
      },
      {
        path: '/detailRemiseBancaire/:id',
        component: DetailRemiseBancaire,
        name: 'c.bodac.remises_bancaires',
      },
      {
        path: '/editionRemiseBancaire/:id',
        component: editRemiseBancaire,
        name: 'm.bodac.remises_bancaires-editionRemise',
      },
      {
        path: '/remiseBancaire/:idRemiseBancaire/reglement',
        component: AddReglementInRemiseBancaire,
        name: 'm.bodac.remises_bancaires',
      },
      {
        path: '/remiseBancaire/:idRemiseBancaire/reglementPiece',
        component: AddReglementPieceRemiseBancaire,
        name: 'm.bodac.remises_bancaires-piece',
      },
      {
        path: '/reglementPiece/:idReglement/:erreur',
        component: AddReglementPieceRemiseBancaire,
        name: 'm.bodac.remises_bancaires-editionPiece',
      },
      {
        path: '/reglement/:idReglement/:erreur',
        component: AddReglementInRemiseBancaire,
        name: 'm.bodac.remises_bancaires-edition',
      },
      {
        path: '/parametrage',
        component: Parametrage,
        name: 'l.parametrage.general',
      },
      {
        path: '/role',
        component: Role,
        name: 'l.parametrage.roles',
      },
      {
        path: '/listeUtilisateurs',
        component: ListeUtilisateurs,
        name: 'l.parametrage.collaborateurs',
      },
      {
        path: '/detailUtilisateur/:id',
        component: DetailCollaborateur,
        name: 'c.parametrage.collaborateurs',
      },
      {
        path: '/listeCategorieGroupeProduitDeductible',
        component: ListeCategorieGroupeProduitDeductible,
        name: 'l.parametrage.categorie_groupe_produit_deductible',
      },
      {
        path: '/listeMotifAnnulationReglement',
        component: ListeMotifAnnulationReglement,
        name: 'l.parametrage.motif_annulation_reglement',
      },
      {
        path: '/listeSocietes',
        component: ListeSocietes,
        name: 'l.parametrage.societe/agence',
      },
      {
        path: '/editionAgenceEditionBat',
        component: EditionAgenceEditionBat,
        name: 'm.parametrage.societe/agence-edition-bat',
      },
      {
        path: '/editionAgenceMailBat',
        component: EditionAgenceMailBat,
        name: 'm.parametrage.societe/agence-mail-bat',
      },
      {
        path: '/editionSociete/:id',
        component: EditionSocietes,
        name: 'm.parametrage.societe/agence',
      },
      {
        path: '/editionSociete/:societeId/ajoutAgence',
        component: ajoutAgence,
        name: 'm.parametrage.societe/agence-ajoutAgence',
      },
      {
        path: '/editionSociete/:societeId/ajoutAgence/:indexAgence',
        component: ajoutAgence,
        name: 'm.parametrage.societe/agence-ajoutAgenceFromSociete',
      },
      {
        path: '/editAgence/:societeId/:agenceId',
        component: ajoutAgence,
        name: 'm.parametrage.societe/agence-modificationAgence',
      },
      {
        path: '/detailSociete/:id',
        component: DetailSociete,
        name: 'c.parametrage.societe/agence',
      },
      {
        path: '/detailRole/:id',
        component: DetailRole,
        name: 'c.parametrage.roles',
      },
      {
        path: '/ajoutUtilisateur',
        component: AjoutUtilisateur,
        name: 'm.parametrage.collaborateurs-add',
      },
      {
        path: '/editionUtilisateur/:id',
        component: EditionUtilisateur,
        name: 'm.parametrage.collaborateurs-edit',
      },
      {
        path: '/createRole',
        component: GestionRole,
        name: 'm.parametrage.roles-add',
      },
      {
        path: '/updateRole/:id',
        component: GestionRole,
        name: 'm.parametrage.roles-edit',
      },
      {
        path: '/listeContratNature',
        component: ListeContratNature,
        name: 'l.baux.contrat_nature',
      },
      {
        path: '/listeContratSignataire',
        component: ListeContratSignataire,
        name: 'l.baux.signataire',
      },
      {
        path: '/journalPaiements',
        component: JournalPaiements,
        name: 'l.baux.journal_paiements',
      },
      {
        path: '/relances',
        component: Relances,
        name: 'l.bodac.relance',
        props: true,
        children: [
          {
            path: 'listeDesRetards/:getLastPayLoad?',
            component: ListeDesRetards,
            name: 'l.bodac.relance-listeDesRetards',
            props: true,
          },
          {
            path: 'listeRelancesSave/:tiersId?',
            component: ListeRelancesSave,
            name: 'l.bodac.relance-listeRelancesSave',
          },
        ],
      },
      {
        path: '/editionRelance/:id',
        component: editionRelance,
        name: 'm.bodac.relance-edition',
      },
      {
        path: '/ajoutRelance',
        component: ajoutRelance,
        name: 'm.bodac.relance',
        props: true,
      },
      {
        path: '/detailRelance/:relanceId/:fromClient?',
        component: DetailRelance,
        name: 'c.bodac.relance',
      },
      {
        path: '/editionEcheancierPaiement/:idFacture',
        component: EditionEcheancierPaiement,
        name: 'm.bodac.factures-editionEcheancierPaiement',
      },
      {
        path: '/modeReglement',
        component: ListeModeReglement,
        name: 'l.parametrage.mode_reglement',
      },
      {
        path: '/parametrageEdition',
        component: ParametrageEdtion,
        name: 'l.parametrage.edition',
      },
      {
        path: '/listeDomiciliationBancaire',
        component: ListeDomiciliationBancaire,
        name: 'l.parametrage.domiciliation_bancaire',
      },
      {
        path: '/ajoutDomiciliationBancaire',
        component: EditionDomiciliationBancaire,
        name: 'm.parametrage.domiciliation_bancaire-add',
      },
      {
        path: '/editionDomiciliationBancaire/:id',
        component: EditionDomiciliationBancaire,
        name: 'm.parametrage.domiciliation_bancaire-edit',
      },
      {
        path: '/DetailDomiciliationBancaire/:id',
        component: DetailDomiciliationBancaire,
        name: 'c.parametrage.domiciliation_bancaire',
      },
      {
        path: '/detailPlanningNumerique/:typeProduit',
        component: DetailPlanningNumerique,
        name: 'c.bodac.commandes-planningNumerique',
      },
      {
        path: '/ajoutSchemaComptable',
        component: EditionSchemaComptable,
        name: 'm.parametrage.schema_comptable-add',
      },
      {
        path: '/editionSchemaComptable/:id',
        component: EditionSchemaComptable,
        name: 'm.parametrage.schema_comptable-edit',
      },
      {
        path: '/schemaComptable',
        component: ListeSchemaComptable,
        name: 'l.parametrage.schema_comptable',
      },
      {
        path: '/natureProduit',
        component: ListeNatureProduit,
        name: 'l.parametrage.support_commercial',
      },
      {
        path: '/detailSchemaComptable/:id',
        component: DetailSchemaComptable,
        name: 'c.parametrage.schema_comptable',
      },
      {
        path: '/disponibiliteReseauTempo',
        component: ReseauTempo,
        name: 'c.bodac.commandes-planningReseauTemporaire',
      },
      {
        path: '/disponibiliteFaceUnitaire',
        component: FaceUnitairePlanning,
        name: 'c.bodac.commandes-faceUnitaire',
      },
      {
        path: '/disponibiliteReseauLc',
        component: AjoutReseauLc,
        name: 'c.bodac.commandes-reseauLc',
      },
      {
        path: '/rechercheProduitSponsoring',
        component: AjoutProduitSponsoringInDcf,
        name: 'c.bodac.commandes-sponsoring',
      },
      {
        path: '/rechercheProduitAutre',
        component: AjoutProduitAutreInDcf,
        name: 'c.bodac.commandes-autre',
      },
      {
        path: '/rechercheProduitPresse',
        component: AjoutProduitPresseInDcf,
        name: 'c.bodac.commandes-presse',
      },
      {
        path: '/disponibiliteReseauMairie',
        component: AjoutReseauMairieInDcf,
        name: 'c.bodac.commandes-reseauMairie',
      },
      {
        path: '/planningReseauLc',
        component: PlanningReseauLc,
        name: 'c.bodac.commandes-planningReseauLc',
      },
      {
        path: '/commentaire',
        component: ListeCommentaire,
        name: 'l.parametrage.commentaire',
      },
      {
        path: '/listeProduitsAchats',
        component: ListeProduitsAchats,
        name: 'l.bodac.catalogue-produitAchat',
      },
      {
        path: '/listeProduitsAchatsLoc',
        component: ListeProduitAchatsLoc,
        name: 'l.bodac.catalogue-produitAchatLoc',
      },
      {
        path: '/ajoutFacesAuReseau/',
        component: AjoutFacesAuReseau,
        name: 'l.bodac.catalogue-ajoutFacesAuReseau',
      },
      {
        path: '/ajoutProduitAssocie/:sens?',
        component: AjoutProduitAssocie,
        name: 'm.bodac.catalogue-ajoutProduitAssocie',
      },
      {
        path: '/listeFormat',
        component: ListeFormat,
        name: 'l.bodac.format',
      },
      {
        path: '/listeTypeReseau',
        component: ListeTypeReseau,
        name: 'l.bodac.type_reseau',
      },
      {
        path: '/listeSecteurActivite',
        component: ListeSecteurActivite,
        name: 'l.parametrage.secteur_activite',
      },
      {
        path: '/listeCivilite',
        component: ListeCivilite,
        name: 'l.parametrage.civilite',
      },
      {
        path: '/listeDispositifSupport',
        component: ListeDispositifSupport,
        name: 'l.gabed.dispositif_support',
      },
      {
        path: '/listeDispositifType',
        component: ListeDispositifType,
        name: 'l.gabed.dispositif_type',
      },
      {
        path: '/listeMaterielLocalisation',
        component: ListeMaterielLocalisation,
        name: 'l.gabed.materiel_localisation',
      },
      {
        path: '/listeMaterielAngleVision',
        component: ListeMaterielAngleVision,
        name: 'l.gabed.materiel_angle_vision',
      },
      {
        path: '/listeMaterielFormat',
        component: ListeMaterielFormat,
        name: 'l.gabed.materiel_format',
      },
      {
        path: '/listeMaterielType',
        component: ListeMaterielType,
        name: 'l.gabed.materiel_type',
      },
      {
        path: '/listeFaceMotifNonCom',
        component: ListeFaceMotifNonCom,
        name: 'l.parametrage.face_motif_non_com',
      },
      {
        path: '/listeMotifBlocage',
        component: ListeMotifBlocage,
        name: 'l.bodac.motif_blocage',
      },
      {
        path: '/listeRegleFacturation',
        component: RegleFacturation,
        name: 'l.presse.regle_facturation',
      },
      {
        path: '/editRegleFacturation/:id',
        component: AddEditRegleFacturation,
        name: 'm.presse.regle_facturation-edit',
      },
      {
        path: '/addRegleFacturation',
        component: AddEditRegleFacturation,
        name: 'm.presse.regle_facturation-ajout',
      },
      {
        path: '/detailRegleFacturation/:id',
        component: DetailRegleFacturation,
        name: 'c.presse.regle_facturation-detail',
      },
      {
        path: '/listeReseauTempo',
        component: ListeReseauTempo,
        name: 'l.bodac.catalogue-reseauTempo',
      },
      {
        path: '/listeReseauLc',
        component: ListeReseauLc,
        name: 'l.bodac.catalogue-reseauLc',
      },
      {
        path: '/listeReseauMairie',
        component: ListeReseauMairie,
        name: 'l.bodac.catalogue-reseauMairie',
      },
      {
        path: '/listeReseauNumerique',
        component: ListeReseauNumerique,
        name: 'l.bodac.catalogue-reseauNumerique',
      },
      {
        path: '/listeFace',
        component: ListeProduitFace,
        name: 'l.bodac.catalogue-face',
      },
      {
        path: '/listeRegroupementProduit',
        component: ListeRegroupementProduit,
        name: 'l.bodac.catalogue-regroupementProduit',
      },
      {
        path: '/addEditRegroupementProduit/:id?',
        component: AddEditRegroupementProduit,
        name: 'm.bodac.catalogue-addEditRegroupementProduit',
      },
      {
        path: '/ajoutProduitsSurRegroupement',
        component: MAjoutProduitsSurRegroupement,
        name: 'm.bodac.catalogue-ajoutProduitsSurRegroupement',
      },
      {
        path: '/detailRegroupementProduit/:id',
        component: DetailRegroupementProduit,
        name: 'c.bodac.catalogue-detailRegroupementProduit',
      },
      {
        path: '/listeTypePointVente',
        component: ListeTypePointVente,
        name: 'l.parametrage.type_point_vente',
      },
      {
        path: '/listeProfilTiers',
        component: ListeProfilTiers,
        name: 'l.parametrage.profil_tiers',
      },
      {
        path: '/listeReseauTempoDispo',
        component: ListeReseauTempoDispo,
        name: 'l.bodac.catalogue-reseauTempoDispo',
      },
      {
        path: '/cartographie',
        component: Cartographie,
        name: 'l.bodac.catalogue-cartographie',
      },
      {
        path: '/suiviAffectation',
        component: SuiviAffectationProduitFace,
        name: 'l.bodac.catalogue-suivi-affectation',
      },
      {
        path: '/listeDelaiReglement',
        component: ListeDelaiReglement,
        name: 'l.parametrage.delai_reglement',
      },
      {
        path: '/listeRelanceOption',
        component: ListeRelanceOption,
        name: 'l.bodac.relance_option',
      },
      {
        path: '/listeDemandeTempo',
        component: ListeDemande,
        name: 'l.bodac.demande_tempo',
      },
      {
        path: '/listeTypeTaxationTlpe',
        component: ListeTypeTaxationTlpe,
        name: 'l.gabed.type_taxation_tlpe',
      },
      {
        path: '/addTypeTaxationTlpe',
        component: AddEditTypeTaxationTlpe,
        name: 'm.gabed.type_taxation_tlpe-add',
      },
      {
        path: '/editTypeTaxationTlpe/:id',
        component: AddEditTypeTaxationTlpe,
        name: 'm.gabed.type_taxation_tlpe-edit',
      },
      {
        path: '/regimeTva',
        component: ListeRegimeTva,
        name: 'l.parametrage.regime_tva',
      },
      {
        path: '/inflation',
        component: Indexation,
        name: 'm.parametrage.indexation',
      },
      {
        path: '/listeCompteAnalytique',
        component: ListeCompteAnalytique,
        name: 'l.parametrage.compte_analytique',
      },
      {
        path: '/remise',
        component: ListeRemise,
        name: 'l.parametrage.libelle_remise',
      },
      {
        path: '/listeAccessoire',
        component: ListeAccessoire,
        name: 'l.gabed.accessoire',
      },
      {
        path: '/listeTypeOt',
        component: listeTypeOt,
        name: 'l.logistique.type_ot',
      },
      {
        path: '/typeOt/:id',
        component: detailTypeOt,
        name: 'c.logistique.type_ot',
      },
      {
        path: '/ajoutTypeOt',
        component: addEditTypeOt,
        name: 'm.logistique.type_ot-ajout',
      },
      {
        path: '/editionTypeOt/:id',
        component: addEditTypeOt,
        name: 'm.logistique.type_ot-edit',
      },
      {
        path: '/visionnerImage/:id/:libelle?',
        component: detailImageProduit,
        name: 'detail-image-produit',
      },
      {
        path: '/typeContact',
        component: ListeTypeContact,
        name: 'l.parametrage.type_contact',
      },
      {
        path: '/listeEcheancePaiement',
        component: EcheancePaiement,
        name: 'l.bodac.echeance_payement',
      },
      {
        path: '/listeRetrocession',
        component: ListeRetrocession,
        name: 'l.bodac.retrocession',
      },
      {
        path: '/listeFactor',
        component: ListeFactor,
        name: 'l.bodac.factor',
      },
      {
        path: '/ajoutFournisseur/:sousTypeFrom',
        component: editionFournisseur,
        name: 'm.bodac.factor',
      },
      {
        path: '/editionFournisseur/:id/:sousTypeFrom',
        component: editionFournisseur,
        name: 'm.bodac.factor-edition',
      },
      {
        path: '/detailFactor/:id/:sousTypeFrom',
        component: detailFournisseur,
        name: 'c.bodac.factor',
      },
      {
        path: '/listeTransmission',
        component: ListeTransmission,
        name: 'l.bodac.transmission',
      },
      {
        path: '/listeReleve',
        component: ListeReleve,
        name: 'l.bodac.catalogue-presse',
      },
      {
        path: '/listeSignatureElectronique/:type',
        component: ListeSignatureElectronique,
        name: 'l.parametrage.signature_electronique',
      },
      {
        path: '/listeIndiceEtValeur',
        component: ListeIndiceEtValeur,
        name: 'l.baux.indice_et_valeur',
      },
      {
        path: '/addIndiceEtValeur',
        component: AddEditIndiceEtValeur,
        name: 'm.baux.indice_et_valeur-add',
      },
      {
        path: '/editIndiceEtValeur/:id',
        component: AddEditIndiceEtValeur,
        name: 'm.baux.indice_et_valeur-edit',
      },
      {
        path: '/listeMarque',
        component: ListeMarque,
        name: 'l.parametrage.marque',
      },
      {
        path: '/listeTags',
        component: ListeTags,
        name: 'l.parametrage.tag',
      },
      {
        path: '/listePays',
        component: ListePays,
        name: 'l.parametrage.pays',
      },
      {
        path: '/listeCampagnes',
        component: ListeCampagnes,
        name: 'l.bodac.campagne',
      },
      {
        path: '/ajoutCampagne',
        component: EditionCampagne,
        name: 'm.bodac.campagne-add',
      },
      {
        path: '/editionCampagne/:id',
        component: EditionCampagne,
        name: 'm.bodac.campagne-edit',
      },
      {
        path: '/detailCampagne/:id',
        component: DetailCampagne,
        name: 'c.bodac.campagne',
      },
      {
        path: '/liste-nomenclature-type',
        component: ListeNomenclatureType,
        name: 'l.parametrage.nomenclature_type',
      },
      {
        path: '/edition-nomenclature-type/:id?',
        component: AddEditNomenclatureType,
        name: 'm.parametrage.nomenclature_type',
      },
      {
        path: '/listePlanMedia/:produitId?',
        component: ListePlanMedia,
        name: 'l.presse.plan_media',
      },
      {
        path: '/listePlanMediaParParution/:parutionId',
        component: ListePlanMedia,
        name: 'l.presse.plan_media-par-parution',
      },
      {
        path: '/listePlanMediaParTiers/:tiersId',
        component: ListePlanMedia,
        name: 'l.presse.plan_media-par-tiers',
      },
      {
        path: '/addPlanMedia',
        component: AddEditPlanMedia,
        name: 'm.presse.plan_media-add',
      },
      {
        path: '/editPlanMedia/:id',
        component: AddEditPlanMedia,
        name: 'm.presse.plan_media-edit',
      },
      {
        path: '/detailPlanMedia/:id',
        component: DetailPlanMedia,
        name: 'c.presse.plan_media',
      },
      {
        path: '/import',
        component: ImportIdelia,
        name: 'm.bodac.import-idelia',
      },
      {
        path: '/liste-secteurs',
        component: ListeSecteur,
        name: 'l.parametrage.secteur',
      },
      {
        path: '/listeEcranNumerique',
        component: ListeProduitEcranNumerique,
        name: 'l.bodac.catalogue-ecran',
      },
      {
        path: '/listeFonctionContact',
        component: ListeFonctionContact,
        name: 'l.parametrage.fonction_contact',
      },
      {
        path: '/listeCompetenceFournisseur',
        component: ListeCompetenceFournisseur,
        name: 'l.parametrage.competence_fournisseur',
      },
      {
        path: '/listeNatureSupportAffiche',
        component: ListeNatureSupportAffiche,
        name: 'l.parametrage.nature_support_affiche',
      },
      {
        path: '/listeFormatAffiche',
        component: ListeFormatAffiche,
        name: 'l.bodac.format_affiche',
      },
      {
        path: '/editionFormatAffiche/:id?',
        component: EditionFormatAffiche,
        name: 'm.bodac.format_affiche',
      },
      {
        path: '/detailFormatAffiche/:id',
        component: DetailFormatAffiche,
        name: 'c.bodac.format_affiche',
      },
      {
        path: '/listeService',
        component: ListeService,
        name: 'l.parametrage.service',
      },
      {
        path: '/editionService/:id?',
        component: EditionService,
        name: 'm.parametrage.service',
      },
      {
        path: '/detailService/:id',
        component: ConsultationFournisseurs,
        name: 'c.parametrage.service',
      },
    ],
    beforeEnter: (to, from, next) => {
      if (LoginRequired(store)) {
        next();
      } else {
        next('/connexion');
      }
    },
  },
  {
    path: '/reinitialisation-mot-de-passe',
    component: ReinitialisationMdp,
    name: 'reinitialisationMotDePasse',
  },
];
